import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, Box } from '@material-ui/core';
import { SizedSmallSectionHeader } from 'containers/AmcDetailsPage/MyContractAndGarantiesTab/MyBeneficiaries/styles';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import { translate } from 'helpers/intl';
import messages from 'containers/AmcDetailsPage/messages';
import ListBoxItem from 'components/ListBoxItem';

export interface BeneficiariesType {
  categorie: string;
  member: string;
}

const MyBeneficiaries = (props: {
  intl: IntlShape;
  beneficiaries: BeneficiariesType[];
}) => {
  const getIcon = (category: any) => {
    if (category.includes('AS')) {
      return 'assure';
    } else if (category.includes('C')) {
      return 'conjoint';
    } else {
      return 'enfant';
    }
  };

  return (
    <Box>
      <Box marginBottom={1.25}>
        <Grid justify="space-between" alignItems="center" container>
          <Grid item xs={5}>
            <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
              {translate({ ...messages.myBeneficiary }, props)}
            </SizedSmallSectionHeader>
          </Grid>
        </Grid>
      </Box>
      <ListBoxItem
        items={
          props.beneficiaries &&
          props.beneficiaries.map((beneficiary) => ({
            title: beneficiary.member,
            icon: getIcon(beneficiary.categorie),
            categorie: beneficiary.categorie,
            smalIcon:
              beneficiary &&
              !beneficiary.categorie.includes('AS') &&
              !beneficiary.categorie.includes('C'),
          }))
        }
        isBeneficiaryBloc
      />
    </Box>
  );
};

export default injectIntl(MyBeneficiaries);

export const TestMyBeneficiaries = injectIntl(MyBeneficiaries);
